import { COMPANY_INFO_LABEL_DEFAULTS, type PortalSettings } from '@l2u/shared/schemas';

export type CompanyInfoLabelKey = keyof typeof COMPANY_INFO_LABEL_DEFAULTS;

export function companyInfoLabel(
  settings: Partial<PortalSettings> | undefined,
  key: CompanyInfoLabelKey,
): string {
  const override = settings?.companyInfoLabels?.[key];
  if (typeof override === 'string' && override.trim().length > 0) return override;
  return COMPANY_INFO_LABEL_DEFAULTS[key];
}

export function contractorTypeOptions(settings: Partial<PortalSettings> | undefined): string[] {
  return settings?.contractorTypeOptions ?? [];
}

export function clusterRegionOptions(settings: Partial<PortalSettings> | undefined): string[] {
  return settings?.clusterRegionOptions ?? [];
}

export function stationOptions(settings: Partial<PortalSettings> | undefined): string[] {
  return settings?.stationOptions ?? [];
}
